import React, { useState } from "react";

export default function ScreenTimeQuiz({
    question = "How many hours a day do you spend on your phone?",
    options = ["1.0 or <", "1.5", "2.0", "2.5", "3.0", "3.5", "4.0 or >"],
    imagesByOption = {},
    resultTitle = "Here is how you compare to the national average",
    frameVariant = "offset-fill-right", // "offset-fill-right" | "offset-border-left"
    maxWidth = "max-w-4xl", // ✨ new parameter for controlling width
}) {
    const [choice, setChoice] = useState(null);

    // choose between the two frame styles
    const backClass =
        frameVariant === "offset-fill-right"
            ? "absolute -bottom-3 -right-2 w-full h-full bg-blue-700 rounded-sm"
            : "absolute -bottom-3 -left-3 w-full h-full border-4 border-blue-700 rounded-sm";

    const frontClass =
        "relative bg-white border-2 border-blue-700 rounded-sm p-6 sm:p-8";

    // Card wrapper
    const CardFrame = ({ children, className = "" }) => (
        <div className="flex justify-center mb-10">
            <div
                className={`relative  ${className} ${maxWidth === "max-w-3xl"
                    ? "max-w-[80%] sm:max-w-2xl"
                    : maxWidth === "max-w-4xl"
                        ? "max-w-[80%] sm:max-w-3xl"
                        : "max-w-[80%]"
                    }`}
            >


                <div className={backClass} />
                <div className={frontClass}>{children}</div>
            </div>
        </div>
    );

    if (!choice) {
        // QUESTION CARD
        return (
            <CardFrame>
                <h4 className="text-blue-700 text-center font-semibold text-lg sm:text-xl mb-5">
                    {question}
                </h4>
                <div className="flex flex-wrap justify-center gap-3">
                    {options.map((opt) => (
                        <button
                            key={opt}
                            onClick={() => setChoice(opt)}
                            className="px-3 py-1.5 rounded-full border-2 border-blue-700 text-blue-700 text-sm font-semibold hover:bg-blue-700 hover:text-white transition"
                            aria-label={`Select ${opt} hours`}
                        >
                            {opt}
                        </button>
                    ))}
                </div>
            </CardFrame>
        );
    }

    // RESULT CARD
    const img = imagesByOption[choice];
    return (
        <CardFrame>
            <h4 className="text-blue-700 text-center font-semibold text-lg sm:text-xl mb-5">
                {resultTitle}
            </h4>

            {img ? (
                <img
                    src={img}
                    alt={`Chart for ${choice} hours of screen time`}
                    className="w-full rounded-sm"
                />
            ) : (
                <div className="w-full text-center text-gray-500 italic py-12">
                    (No chart provided for “{choice}”)
                </div>
            )}

            <div className="mt-6 flex justify-center">
                <button
                    onClick={() => setChoice(null)}
                    className="px-4 py-1.5 rounded-full border-2 border-blue-700 text-blue-700 text-sm font-semibold hover:bg-blue-700 hover:text-white transition"
                >
                    Reset
                </button>
            </div>
        </CardFrame>
    );
}
